import React, { useEffect, useState } from 'react';

import { procurementReportApi } from '@/main/api';
import KogModalSideComponent from '@/main/components/modal/ModalSide';
import SecondaryButton from '@/main/components/shared/button/secondaryButton';
import LoadingComponent from '@/main/components/shared/loading/loadingComponent';
import { getTranslateByKey } from '@/main/services/utils';
import { firstLetterToUpperCase } from '@/main/services/utilsString';

import * as S from './styles';
import { DynamicReportHistoricalDetailsResponse } from '@/main/models/response';
import CopyToClipboardText from '@/main/components/shared/copyToClipboardText/copyToClipboardText';

interface IhistoricalDetailsProps {
  open: boolean;
  closeModal: () => void;
  guidDynamicReportHistorical: string;
  actionName: string;
}

function HistoricalDetails({
  open,
  closeModal,
  guidDynamicReportHistorical,
  actionName
}: IhistoricalDetailsProps) {

  const [isLoadingInfo, setIsLoadingInfo] = useState<boolean>(true);
  const [details, setDetails] = useState<DynamicReportHistoricalDetailsResponse[]>([]);

  useEffect(() => {
    if (open) {
      setIsLoadingInfo(true);
      procurementReportApi
        .getDynamicReportHistDetails(guidDynamicReportHistorical)
        .then(response => {
          const resultData = response.data.result;
          setDetails(resultData);
        })
        .catch(() => { })
        .finally(() => {
          setIsLoadingInfo(false);
        });
    }
  }, [guidDynamicReportHistorical]);

  function renderValues(value: string, isCopy: boolean){
    if (!isCopy){
      return value;
    }
    return (
      <CopyToClipboardText
        label={getTranslateByKey('dynamicReportHistorical.copyQuery')}
        valueToCopy={value}
        hideIcon={true}
      >
        {getTranslateByKey('dynamicReportHistorical.copyQuery')}
      </CopyToClipboardText>
    )
  }

  return (
    <>
      {open && (
        <KogModalSideComponent
          open={open}
          closeModal={() => {
            closeModal(), setDetails([]);
          }}
          title={getTranslateByKey('information.historyDetails')}
          id="id-dynamicReport-historical-modal-scroll">
          <S.AccordionContainer>
            <S.AccordionTitle>
              {actionName}
            </S.AccordionTitle>
            {!isLoadingInfo ?
              (<S.AccordionDetailsHistory>
                {details && details.map(item => (
                  <S.BoxLabelItem>
                    <S.ContainerLabel>
                      <S.LabelItem>
                        {firstLetterToUpperCase(
                          `${getTranslateByKey('SupplierInventoryHistory.field')}:`
                        )}
                      </S.LabelItem>
                      <S.LabelResult>{item.field}</S.LabelResult>
                    </S.ContainerLabel>
                    <S.ContainerLabel>
                      <S.LabelItem>{`${getTranslateByKey( 'information.from' )}:`}</S.LabelItem>
                      <S.LabelResult>{renderValues(item.from, item.isCopy)}</S.LabelResult>
                    </S.ContainerLabel>
                    <S.ContainerLabel>
                      <S.LabelItem>{`${getTranslateByKey( 'information.to' )}:`}</S.LabelItem>
                      <S.LabelResult>{renderValues(item.to, item.isCopy)}</S.LabelResult>
                    </S.ContainerLabel>
                  </S.BoxLabelItem>
                ))}
              </S.AccordionDetailsHistory>) : <LoadingComponent />}
          </S.AccordionContainer>
          <div
            className="d-flex justify-content-center"
            style={{ marginTop: 10 }}>
            <SecondaryButton id="id-dynamicReport-historical-button-back" onClick={() => closeModal()}>
              {getTranslateByKey('information.back')}
            </SecondaryButton>
          </div>
        </KogModalSideComponent>
      )}
    </>
  );
}

export default HistoricalDetails;
